export default __webpack_public_path__ + "static/media/mission.be4c5622.jpg";